// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
[data-v-d7a439ba] .van-rate__item {
  margin-right: 2px;
}
[data-v-d7a439ba] .van-button--mini {
  height: 24px;
  padding: 0 8px;
  font-size: 11px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
